import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './history-info.hbs'
import historyInfoRow from './history-info-row.hbs'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import i18n from 'scoreboard/components/i18n'
import globals from 'scoreboard/components/globals'
import loadingDots from 'scoreboard/components/loading-dots.hbs'
import constants from 'scoreboard/components/constants'
import appDisplay from 'scoreboard/components/app-display'
import Tooltip from './tooltip'
import SendTo from './send-to'
import SendToOptions from './send-to-options'
import excelExport from 'scoreboard/components/export/excel-export'
import sections from 'scoreboard/components/sections'
import center from 'scoreboard/components/min-height-vertical-center-msg.hbs'
import user from 'scoreboard/components/user'
import calendars from 'scoreboard/components/calendars'
import groupType from 'scoreboard/admin/principals/groups/group-type'
import highlight from 'scoreboard/components/highlight'
import DataType from 'scoreboard/datasets/model/data-type'
const { DATE } = DataType

function defaultFull(model) {
	return model.section !== 'scorecards'
}

function url(model, full) {
	var url = 'api/' + sections.toUrl(model.section) + '/' + model.id + '/history' +
		'?calendarPeriodId=' + globals.periodId
	if (full) {
		url += '&full=true'
	}
	return url
}

var HistoryInfo = Backbone.View.extend({

	// this.model is the domain object (e.g. scorecard item)
	// this.options.history is the initial history to render
	// this.options.full is whether the passed in history is for the current
	// period or the full history

	// this.fullHistory is a cached version of the full history (if available)
	// this.periodHistory is a cached version of the period history (if available)

	className: 'history-info',

	events: {
		'click .labeled-toggle .option': 'toggleAllEvents',
		'click .export' : 'sendTo'
	},

	initialize: function(options) {
		this.options = options
		this.full = this.options.full
		this.label = this.options.label
		this.export = this.options.export

		let currentPeriodLabel = calendars.periodsById[globals.periodId].label
		this.periodEventsLabel = i18n.get('common.history.valuesAndNotes', currentPeriodLabel)
		this.allEventsLabel = i18n.get('objectHistory.allEvents')
		this.headerText = this.export ? this.exportLabel() : i18n.get('common.auditWithLabel', this.label)
		this.cacheHistory(this.options.history)

		// #16777 - Used to styles group labels on client because
		// concatenation of `groupname + (type)` is done on server
		const groupLabels = _.values(groupType.messageKeysByType())
		this.groupRegEx = new RegExp(`\\((${groupLabels.join('|')})\\)$`)
	},

	cacheHistory: function(history) {
		if (this.full) {
			this.fullHistory = history
		} else {
			this.periodHistory = history
		}
	},

	render: function() {
		this.$el.empty().append(template({
			headerText: this.headerText,
			strictViewer: user.isStrictViewer()
		}))

		if (!this.export && this.model.section === 'scorecards') {
			this._toggle = new LabeledToggle({
				options: [{
					value: 'currentPeriod',
					label: this.periodEventsLabel
				}, {
					value: 'allEvents',
					label: this.allEventsLabel
				}]
			})
			this.$('.panel-header').addClass('panel-header-large')
			this.$('.toggle-container').append(this._toggle.el)
			this._toggle.render()
			this.$('.instruction-banner').removeClass('is-not-displayed')
		}
		this.toggleAllEvents()

		return this
	},

	renderHistory: function(history) {
		let html = ''
		if (history.length) {
			this.exportModel = []
			_.each(history, h => {
				// #38193 we were escaping the description here, but the server is
				// already sending back escaped text, so this would do it again,
				// causing the character codes to show in the UI
				h.descriptionMarkup = h.description && h.description.replace(this.groupRegEx, '<span class="post-label">$&</span>')

				if (h.user.id == -4) {
					h.datasetProcessUser = true
				}

				// Highlight appropriate quoted values in the description
				_.each(['oldValue', 'newValue', 'extraInfo1', 'extraInfo2'], f => {
					if (h[f]) {
						h.descriptionMarkup = _.replace(h.descriptionMarkup, `'${h[f]}'`, highlight(h[f]))
					}
				})

				html += historyInfoRow(h)
				this.exportModel.push({
					date: h.date
				})
			})
		} else {
			// #32468 empty state message for non-scorecard items/"All Events"
			let emptyMessage = i18n.get('objectHistory.noEvents')
			// empty state message for a scorecard when displaying events for a period
			if (this.model.section === 'scorecards' && !this.full) {
				let periodLabel = calendars.periodsById[globals.periodId].label
				emptyMessage = i18n.get('objectHistory.noValuesOrNotes', periodLabel)
			}
			html = '<tr><td colspan="4">' + center(emptyMessage) + '</td></tr>'
		}
		this.$('tbody').empty().append(html)
	},

	toggleAllEvents: function() {
		var currentPeriod = this.model.section === 'scorecards' &&
			this.$('.selected').data('value') === 'currentPeriod'

		// when exporting, use whatever state was requested and ignore the selector
		var periodHistory = this.export ? !this.full : currentPeriod
		if (periodHistory) {
			this.full = false
			this.fetchAndRenderHistory(this.periodHistory)
		} else {
			this.full = true
			this.fetchAndRenderHistory(this.fullHistory)
		}
	},

	sendTo: function(e) {
		var target = $(e.currentTarget)

		const exportOptions = {
			exportURL: `${sections.toUrl(this.model.section)}/${this.model.id}/history`,
			options: ['full=' + this.full],
			excelFn: this.exportTable.bind(this),
			includeScheduledCount: false, // 23550
			immediate: true // 23999
		}
		const options = [
			SendToOptions.printer(exportOptions),
			SendToOptions.word(exportOptions),
			SendToOptions.excel(exportOptions),
			SendToOptions.pptx(exportOptions),
			SendToOptions.pdf(exportOptions)
		]

		this.sendToTooltip = new Tooltip({
			attachTo: target,
			content: new SendTo({
				heading: this.$('h1').text(),
				sendToOptions: _.flatten(options)
			}),
			placement: 'below',
			arrow: 'right',
			extraClass: 'has-bootslide-menu'
		}).render()
	},

	exportTable() {
		var opts = {
			label: this.exportLabel(),
			dataAttributes: {
				modelLookup: this._exportModelLookup.bind(this)
			}
		}
		return excelExport.saveTableAsFile(this.$('tbody'), opts)
	},

	fetchAndRenderHistory: function(cache) {
		if (cache) {
			this.renderHistory(cache)
		} else {
			this.loadingTimeout = setTimeout(function() {
				this.$('tbody').html('<tr><td class="loading" colspan="4">' + loadingDots() + '</td></tr>')
			}.bind(this), constants.LOADING_TIME)

			$.get(url(this.model, this.full), function(response) {
				clearTimeout(this.loadingTimeout)
				var history = response.history
				this.label = _.defaultTo(response.label, this.label)
				this.cacheHistory(history)
				this.renderHistory(history)
			}.bind(this))
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this._toggle, this.sendToTooltip], 'remove')
	},

	exportLabel: function() {
		var fullLabel = this.full ? this.allEventsLabel : this.periodEventsLabel
		return i18n.get('common.export.auditWithLabel', this.label, fullLabel)
	},

	/**
	 * Instructs the excel export to format dates as dates.
	 * Everything else for this view is text.
	 *
	 * @param {Number} tableRowIndex 0-based, includes header row(s)
	 * @see excel-export.js#saveTableAsFile
	 */
	_exportModelLookup(tableId, tableRowIndex, jqCell) {
		const colIndex = jqCell.index()
		let cellData = {}
		if (tableRowIndex > 0 && colIndex === 0 && this.exportModel) {
			cellData = {
				value: this.exportModel[tableRowIndex-1].date,
				dataType: DATE
			}
		}
		return cellData
	}

}, {

	display: function(model, label) {
		var full = defaultFull(model)
		appDisplay.dialog($.get(url(model, full)), function(response) {
			return new HistoryInfo({ model: model, history: response.history, full: full, label: label })
		}.bind(this))
	},

	exportDisplay: function(section, id, full) {
		var model = {section: section, id: id}
		appDisplay.display($.get(url(model, full)), function(response) {
			return new HistoryInfo({
				model: model,
				history: response.history,
				full: full,
				label: response.label,
				export: true
			})
		}.bind(this))
	}

})

export default HistoryInfo

HistoryInfo.__filename__ = 'components/history-info.js'
